import { extendObservable } from 'mobx'
import moment from 'moment'
import find from 'lodash/find'

import { emailApi, logApi } from '@atheneum/api'

class LogStore {
  constructor () {
    extendObservable(this, {
      logs: [],
      count: null,
      loading: null,
      dateFrom: moment('2010'),
      dateTo: moment(),
      objectId: null,
      type: '',
      objectType: '',
      diff: null,
      diffTables: [],
      eplExtractEmail: null
    })
  }

  clean () {
    this.logs.replace([])
    this.count = null
    this.dateFrom = moment('2010')
    this.dateTo = moment()
    this.id = null
    this.type = null
    this.objectType = ''
    this.objectId = null
  }

  setVal = (key, val) => {
    this[key] = val
    this.logs.replace([])
    this.count = null
    this.getLogs()
  }

  getLogs = async () => {
    const skip = this.logs.length

    const { rows, count } = await logApi.getLogs({
      type: this.type,
      objectType: this.objectType,
      dateFrom: this.dateFrom.toString('YYYY-MM-DD'),
      dateTo: this.dateTo.toString('YYYY-MM-DD'),
      objectId: this.objectId,
      skip
    })
    this.logs.replace([...this.logs, ...rows.map(generateLinks)])
    this.count = count
  }

  getDiff = async revisionHash => {
    const res = await logApi.getDiff(revisionHash)
    this.diff = res
    this.diffTables.replace(res.data.tables)
  }

  async getExtractEplsEmailInfo (emailId) {
    this.loading = true
    try {
      const eplExtractEmail = await emailApi.getOne(emailId)
      this.eplExtractEmail = eplExtractEmail
      this.loading = false
    } catch (err) {
      this.error = err
    }
  }
}

function generateLinks (log) {
  const links = {}
  for (const logObject of log.logObjects) {
    switch (logObject.type) {
      case 'parentAccount':
        links[logObject.key] = {
          to: `/client-search/parent-account/${logObject.objectId}`,
          text: logObject.text
        }
        break
      case 'currentUser':
        links.user = {
          to: `/employee/${logObject.objectId}`,
          text: logObject.text
        }
        break
      case 'invoicingEntity':
        const parentLogObject = find(log.logObjects, { type: 'parentAccount' })
        links[logObject.key] = {
          to: `/client-search/parent-account/${
            parentLogObject.objectId
          }/invoicing-entities/${logObject.objectId}`,
          text: logObject.text
        }
        break
      case 'fee':
        const projectObject = find(log.logObjects, { type: 'project' })
        if (projectObject) {
          links[logObject.key] = {
            to: `/project/${projectObject.objectId}/fee/${logObject.objectId}`,
            text: 'fee'
          }
        } else {
          links[logObject.key] = {
            to: ``,
            text: 'fee'
          }
        }
        break
      default:
        links[logObject.key] = {
          to: `/${logObject.type}/${logObject.objectId}`,
          text: logObject.text
        }
        break
    }
  }
  return {
    ...log,
    links
  }
}

export default LogStore
